import { z } from 'zod';

import { USER_TYPE } from '@/lib/data/domains/user';

export const SettingsFormSchema = z
  .object({
    id: z.string(),
    concurrencyToken: z.string().optional(),
    firstName: z.string(),
    lastName: z.string(),
    phone: z.string(),
    email: z.string().email('Please enter valid email'),
    userType: z.nativeEnum(USER_TYPE),
    roles: z.array(z.unknown()),
  })
  .superRefine((data, ctx) => {
    if (!data.firstName || !data.firstName.trim()) {
      ctx.addIssue({
        path: ['firstName'],
        message: 'First name is required',
        code: 'custom',
      });
    }

    if (!data.lastName || !data.lastName.trim()) {
      ctx.addIssue({
        path: ['lastName'],
        message: 'Last name is required',
        code: 'custom',
      });
    }

    if (!data.phone || !data.phone.trim()) {
      ctx.addIssue({
        path: ['phone'],
        message: 'Phone number is required',
        code: 'custom',
      });
    }

    if (!data.email || !data.email.trim()) {
      ctx.addIssue({
        path: ['email'],
        message: 'Email is required',
        code: 'custom',
      });
    }
  });

export const ChangePassordFormSchema = z
  .object({
    currentPassword: z.string(),
    password: z.string(),
    confirmPassword: z.string(),
  })
  .superRefine((data, ctx: any) => {
    if (!data.currentPassword || !data.currentPassword.trim()) {
      ctx.addIssue({
        path: ['currentPassword'],
        message: 'Current password is required',
        code: 'custom',
      });
    }

    if (!data.password || !data.password.trim()) {
      ctx.addIssue({
        path: ['password'],
        message: 'Password is required',
        code: 'custom',
      });
    }

    if (!data.confirmPassword || !data.confirmPassword.trim()) {
      ctx.addIssue({
        path: ['confirmPassword'],
        message: 'Confirm password is required',
        code: 'custom',
      });
    }

    if (data.password !== data.confirmPassword) {
      ctx.addIssue({
        path: ['confirmPassword'],
        message: 'Confirm password does not match password',
        code: 'custom',
      });
    }
  });
